import { gradeLabes } from "./general";

export const isValidString = str => str !== null && str !== undefined && str.trim() !== "";

export const isEmptyObject = (obj) => {
   if (obj != null || obj != undefined) return Object?.keys(obj)?.length === 0;
   return false;
}

export const isValidObject = obj => {
   if (obj === null || obj === undefined) {
      return false
   }
   return typeof obj === 'object'
}

export const serialNo = (i, activePage, pageSize = 10) => ((activePage - 1) * pageSize) + (i + 1);

export const URLRegex = /^(http|https)/;

export const ageRange = ["3", "4", "5", "6", "7-8", "9-11", "12-14", "15-17"];

// export const getAgeRange = (value) => {
//    let [minAge, maxAge] = value?.split("-");
//    maxAge = maxAge ?? minAge;
//    return [minAge, maxAge];
// }

export const getAgeRange = (value) => {
   let [minAge, maxAge] = value?.split("-");
   minAge = parseInt(minAge);
   maxAge = maxAge ?? minAge;
   maxAge = parseInt(maxAge);
   return [minAge, maxAge];
};

export const mediaFormats = {
   video: ["mp4", "mov"],
   image: ["jpeg", "jpg", "png"]
}

export const getMediaType = url => {
   const ext = url.split(".").pop().toLowerCase();
   return Object.entries(mediaFormats).filter(([key, list]) => list.indexOf(ext) >= 0)?.[0]?.[0]
}

export const getKeyByValue = (object, value) => {
   if (isValidObject(object))
      return Object?.keys(object)?.find(key => object[key] === value);
   else
      return null
}

export const duplicateFileValidation = (meta, arrayOfFile) => {
   let checkDuplicateFile = arrayOfFile;
   if (checkDuplicateFile.length > 0) {
      return checkDuplicateFile.find(e => e.name === meta.name && e.size === meta.size && e.type === meta.type)
   }
};

export const getGrade = data => {
   const { current_grade, grade_status } = data;
   let res = {}
   switch (grade_status) {
      case "GradeAwaited":
         res = {
            color: "warning",
            grade: "Grade Awaited",
            resubmission: false
         }
         break;
      case "Graded":
         res = {
            color: "success",
            grade: `${current_grade} (${gradeLabes[current_grade]})`,
            resubmission: false
         }
         break;
      case "UnderReview":
         res = {
            color: "warning",
            grade: `Under Review (${current_grade})`,
            resubmission: false
         }
         break;
      case "Reviewed":
         res = {
            color: "success",
            grade: `${current_grade} (${gradeLabes[current_grade]})`,
            resubmission: true
         }
         break;
      default:
         res = {
            color: "success",
            grade: `${current_grade} (${gradeLabes[current_grade]})`,
            resubmission: false
         }
   }

   if (current_grade == "NA") {
      res["color"] = "danger";
   }

   return res;
}

export const isMobileDevice = () => {
   let check = false;
   (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
   return check;
}

export const getFileCategory = (fileType) => {
   const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
   const documentExtensions = ['pdf', 'doc', 'docx', 'txt'];
   const videoExtensions = ['mp4', 'mov', 'avi', 'mkv'];

   if (imageExtensions.includes(fileType)) {
      return 'Image';
   } else if (documentExtensions.includes(fileType)) {
      return 'Document';
   } else if (videoExtensions.includes(fileType)) {
      return 'Video';
   } else {
      return 'Other';
   }
};

export const isJsonString = str => {
   try {
      JSON.parse(str);
   } catch (e) {
      return false;
   }
   return true;
}